import styled, { keyframes} from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const Overlay = styled.div<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const Content = styled.div`
  background: #fff;
  border-radius: var(--radius-default);
  max-width: 500px;
  width: 90%;
  position: relative;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  animation: ${fadeIn} 0.3s ease;
  transition: opacity 0.3s ease;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacement-default);
  margin-bottom: 1rem;
  background: var(--neutral-0);
  padding-inline: var(--spacement-xxlarge);
  padding-block: var(--spacement-large);
  border-top-left-radius: var(--radius-default);
  border-top-right-radius: var(--radius-default);
`;

export const Title = styled.h2`
  font-weight: bold;
  margin: 0;
  flex: 1;
  color: var(--primary-800-light);
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-inline: var(--spacement-xxlarge);
  padding-block: var(--spacement-large);
  border-top: 1px solid var(--neutral-2);
`;

